import { motion } from "framer-motion";

const chapters = [
  {
    num: "01",
    title: "Gratitude in the Name",
    body: "\"Obrigado\" means thank you in Portuguese — a tribute to the partners who move with us. \"PH\" carries the founder's initials; \"Holdings\" carries a much bigger vision for managing resources with discipline and pride.",
    testid: "manifesto-chapter-1",
  },
  {
    num: "02",
    title: "Between the Mine and the Market",
    body: "We close the gap between raw mining output and exacting customer requirements. Our edge is an efficient system of mining aggregation and mineral logistics across the local corridor — reliable tonnage, delivered on specification, every time.",
    testid: "manifesto-chapter-2",
  },
  {
    num: "03",
    title: "A Global Ambition",
    body: "Our objective: a 25% share of South Africa's chrome concentrate exports and 30,000 tons under annual contract. We serve clients across Asia, Europe and every market where high-grade chrome matters — no borders, no favourites.",
    testid: "manifesto-chapter-3",
  },
];

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-section" className="px-6 md:px-12 lg:px-24 py-24 md:py-32">
    <div className="grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4">
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-chrome mb-6">The Obrigado Manifesto</p>
        <h2 className="font-display font-semibold tracking-tighter text-4xl sm:text-5xl md:text-6xl leading-[0.95] text-ink" data-testid="manifesto-heading">
          WHY WE<br />EXIST.
        </h2>
        <p className="mt-8 text-base leading-relaxed text-slate-600 max-w-sm">
          A dynamic mining company built on gratitude, engineered for scale.
        </p>
      </div>
      <div className="lg:col-span-8 space-y-0">
        {chapters.map((c, i) => (
          <motion.article
            key={c.num}
            data-testid={c.testid}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="grid sm:grid-cols-12 gap-4 sm:gap-8 py-10 md:py-14 border-t border-ink/10 group"
          >
            <div className="sm:col-span-2">
              <span className="font-display font-semibold text-4xl md:text-5xl text-outline-blue group-hover:text-chrome transition-colors duration-500">{c.num}</span>
            </div>
            <div className="sm:col-span-4">
              <h3 className="font-display font-semibold text-2xl md:text-3xl tracking-tight text-ink leading-snug">{c.title}</h3>
            </div>
            <div className="sm:col-span-6">
              <p className="text-base md:text-lg leading-relaxed text-slate-600">{c.body}</p>
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
